import { atom } from "jotai";
import { StaffGenreFilter } from "views/StaffSchedule/tools";

export const staffSettingsStaffGenreFilterAtom = atom<StaffGenreFilter>("ALL");
export const staffSettingsSearchFilterAtom = atom("");
